<template>
  <div class="product">
    <div class="banner_content">
      <img src="../assets/img/product/orbital/banner.png" width="648" height="183"/>
      <div class="div_font">
        <div class="div_1">
          <i class="font_1">轨道</i>
          <i class="font_2">家庭网络般的体验</i>
        </div>
        <div class="div_2">
          更灵活的网络服务方案，提供覆盖全列的信息化服务，打造丝滑的整车音视频同步体验。
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="tabClick" :stretch="true" class='custom-tabs'>
      <el-tab-pane label="解决方案" name="service">
      </el-tab-pane>
      <el-tab-pane label="轨道产品" name="product">
      </el-tab-pane>
    </el-tabs>
    <div class="detail_content">
      <div v-if="activeName == 'service'" class="detail">
        <div class="detail_font">科可瑞尔车载Wi-Fi系统，是基于边缘计算的分布式架构系统，该系统包含Wi-Fi服务器、Wi-Fi控制器、Wi-Fi AP。系统具有扩展方便灵活，可支持多编组应用等特点。服务器具备多路网络通信接口，提供数据和信息的存储、处理分发和控制功能；4G网关集成多路LTE模块提供通信功能，作为系统的互联网出口；无线访问节点(WAP)提供Wi-Fi信号覆盖和接入服务，无线终端通过WAP接入系统网络，访问车载Wi-Fi服务器的内部娱乐内容或通过4G网关连接互联网。 <br>该系统于航空领域经过多年的装机验证，已充分证明其安全、成熟、可靠。同时此系统已应用于国内新一代智能列车，如复兴号高铁、和谐号动车组等。国外装车如哥斯达黎加、罗马尼亚、阿联酋等轨道交通项目。</div>
        <div class="detail_d2">
          <img src="../assets/img/product/orbital/o_img.png" width="666" height="774" style="margin-right: 50px;"/>
          <div>
            <div class="detail_title">
              <img src="../assets/img/product/orbital/sj.png" width="14" height="20" class="title_img"/>
              <i class="i-first-child">系统主要技术特点</i>
            </div>
            <i class="detail_font">1.支持同时千人在线；<br> 2.系统涵盖全方位信息化服务；<br> 3.系统采用基于边缘计算的分布式架构；<br> 4.车头车尾双控制器，具备负荷均衡、多端备份的能力。  </i>
          </div>
        </div>

      </div>

      <div v-if="activeName == 'product'">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(1)">
              <img src="../assets/img/product/orbital/p1.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载WiFi控制器</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(2)">
              <img src="../assets/img/product/orbital/p2.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载4G网关</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(3)">
              <img src="../assets/img/product/orbital/p3.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载WiFi模块</span>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(4)">
              <img src="../assets/img/product/orbital/p4.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载POE-AP</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(5)">
              <img src="../assets/img/product/orbital/p5.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载AP</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(6)">
              <img src="../assets/img/product/orbital/p6.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载三层交换机（3U）</span></div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(7)">
              <img src="../assets/img/product/orbital/p7.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载三层交换机(1U)</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(8)">
              <img src="../assets/img/product/orbital/p8.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载三层交换机(3U)POE供电</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(9)">
              <img src="../assets/img/product/orbital/p9.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">车载二层交换机</span></div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
    <el-dialog
        :visible.sync="centerDialogVisible"
        width="80%"
        center>
      <div v-if="productIndex === 1" class="dialog_content">
        <img src="../assets/img/product/orbital/p1-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载WiFi控制器</span>
          轨道交通车载 AP，主要为旅客提供WiFi无线接入功能。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 采用X86平台工业级四核处理器，内存8G；
          <br>· 支持AP AC管理；
          <br>· 支持2路 4G/5G 移动网络；
          <br>· 支持负载均衡；
          <br>· 提供2路USB调试接口；
          <br>· 提供4路1000M以太网接口；
          <br>· 提供完善的设备BIT功能，32GB eMMC；
          <br>· 最大支持4路 SATA硬盘；
          <br>· 功耗≤30W；
          <br>· 外形：1U/3U；
          <br>· 工作温度：-25℃~55℃， 存储温度：-55℃~85℃。
        </div>
      </div>
      <div v-if="productIndex === 2" class="dialog_content">
        <img src="../assets/img/product/orbital/p2-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载4G网关</span>
          轨道交通车载4G网关提供4路4G LTE上网功能，通过4G LTE通路提供认证业务，下载媒体文件，远程软件升级和上传Log记录。4G网关通过以太网接口连接到车载交换机网络。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · CPU采用NXP IMX6Q系列微处理器，4核主频高达1GHz ,主存储器DDRAM，容量1GB；
          <br>· 提供1路USB调试接口；
          <br>· 提供1路10/100/1000BT 以太网接口；
          <br>· 支持负载均衡 ·支持硬件看门狗功能；
          <br>· 电源要求：+110V/0.5A，常温下功耗小于20W；
          <br>· 外形尺寸：1U标准机箱；
          <br>· 设备重量：≤2.5Kg；
          <br>· 外部接口：M12接口；
          <br>· 工作温度：-1
        </div>
      </div>
      <div v-if="productIndex === 3" class="dialog_content">
        <img src="../assets/img/product/orbital/p3-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载WiFi模块</span>
          车载WiFi模块，集成WIFI控制器和网关功能，提供2路4G/5G上网功能，WIFI AC管理功能，局域网点播服务器功能，通过4G/5G通路提供认证业务，下载媒体文件，远程软件升级和上传log记录。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 采用X86平台工业级四核处理器，内存8G；
          <br>· 支持AP AC管理；
          <br>· 支持2路 4G/5G 移动网络；
          <br>· 支持负载均衡；
          <br>· 提供2路USB调试接口；
          <br>· 提供2路10/100/1000M以太网接口；
          <br>· 提供完善的设备BIT功能，32GB eMMC；
          <br>· 最大支持4路 SATA硬盘；
          <br>· 功耗≤30W；
          <br>· 外形：1U/3U；
          <br>· 工作温度：-25℃~55℃，存储温度：-55℃~85℃。
        </div>
      </div>
      <div v-if="productIndex === 4" class="dialog_content">
        <img src="../assets/img/product/orbital/p4-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载POE-AP</span>
          轨道交通车载 AP，主要为旅客提供WiFi无线接入功能。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          CPU采用Qualcomm QCA9550，MIPS处理器，DDR2内存512MB，NAND flash容量128MB；
          <br>支持无线标准：IEEE 802.11a/b/g/n/ac wave2；
          <br>支持的以太网标准：IEEE802.3/3i/3u/3ab；
          <br>最大接入速率：1734Mbps；
          <br>最大发射功率：≤20dBm；
          <br>AP提供1路串口调试接口，波特率软件可调，最高可达115200bps；
          <br>外部通讯接口：M12千兆网络接口；
          <br>提供设备工作状态指示灯；
          <br>支持120个以上用户2M码流高清视频点播；
          <br>电源要求：POE48V/0.27A，常温下最大功耗小于13W；
          <br>设备重量：≤1Kg；
          <br>工作温度：-40℃～+70℃，存储温度：-55℃～+85℃。
        </div>
      </div>
      <div v-if="productIndex === 5" class="dialog_content">
        <img src="../assets/img/product/orbital/p5-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载AP</span>
          轨道交通车载 AP，主要为旅客提供WiFi无线接入功能。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · CPU采用Qualcomm IPQ4029 SOC，集成四核ARM Cortex-A7处理器，DDR3内存512MB，NAND flash 容量128MB；
          <br>· 支持无线标准：IEEE 802.11a/b/g/n/ac wave2；
          <br>· 支持的以太网标准：IEEE802.3/3i/3u/3ab；
          <br>· 最大接入速率：1734Mbps； ·最大发射功率：≤20dBm；
          <br>· AP提供1路串口调试接口，波特率软件可调，最高可达115200bps；
          <br>· 外部通讯接口：M12千兆网络接口；
          <br>· 提供设备工作状态指示灯；
          <br>· 支持120个以上用户2M码流高清视频点播；
          <br>· 电源要求：DC24V/2A，常温下最大功耗小于30W；
          <br>· 设备重量：≤1.2Kg；
          <br>· 工作温度：-40℃～+70℃，存储温度：-55℃～+85℃。
        </div>
      </div>
      <div v-if="productIndex === 6" class="dialog_content">
        <img src="../assets/img/product/orbital/p6-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载三层交换机(3U)</span>
          车载三层交换机专业为车载系统集成而设计，主要应用于高铁、轨道交通等领域，为车载信息系统以及车载以外的系统集成提供稳定可靠的以太网络和数据传输。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 电源输入DC24V
          <br>· 最大功耗15w
          <br>· 工作温度-40 ~ 85度
          <br>· 存储温度-55 ~ 95度
          <br>· 外形尺寸：180mm（长）*100mm（宽）*121.92mm（高）
          <br>· 16个千兆网口（可增加到24个）
          <br>· DB9连接器连接
          <br>· Web端管理
          <br>· 在线固件升级
          <br>· 主干线路硬件Bypass技术
          <br>· 支持网络自配置
        </div>
      </div>
      <div v-if="productIndex === 7" class="dialog_content">
        <img src="../assets/img/product/orbital/p7-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载三层交换机(1U)</span>
          车载三层交换机专业为轨道交通量身定做，主要用在CRH和Metro车上系统集成，用于车上以太网与司机室设备互联，并可作为车上与车站系统对接的网关，与地面建立联接。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 电源输入DC110V
          <br>· 最大功耗20w
          <br>· 工作温度-40 ~ 85度
          <br>· 存储温度-40 ~ 85度
          <br>· 长宽高  标准1U机箱
          <br>· 转发速率1488099pps
          <br>· 支持动态路由、静态路由、
          <br>· 支持IP组播、QoS、广播风暴控制
        </div>
      </div>
      <div v-if="productIndex === 8" class="dialog_content">
        <img src="../assets/img/product/orbital/p8-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载三层交换机(3U)POE供电</span>
          车载三层交换机专业为车载系统集成而设计，主要应用于高铁、轨道交通等领域，为车载信息系统以及车载以外的系统集成提供稳定可靠的以太网络和数据传输。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 电源输入DC24V,DC48V(POE)
          <br>· 最大功耗15w
          <br>· 工作温度-40 ~ 85度
          <br>· 存储温度-55 ~ 95度
          <br>· 外形尺寸：180mm（长）*100mm（宽）*121.92mm（高）
          <br>· 16个千兆网口（可增加到24个）
          <br>· DB9连接器连接
          <br>· Web端管理
          <br>· 在线固件升级
          <br>· 主干线路硬件Bypass技术
          <br>· 支持网络自配置
        </div>
      </div>
      <div v-if="productIndex === 9" class="dialog_content">
        <img src="../assets/img/product/orbital/p9-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">车载二层交换机</span>
          科可瑞尔车载二层交换机专业为车载系统集成而设计，主要应用于高铁、轨道交通等领域，为车载信息系统以及车载以外的系统集成提供稳定可靠的以太网络和数据传输。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 电源输入DC24V ·最大功耗15w
          <br>· 工作温度-40 ~ 85度
          <br>· 存储温度-40 ~ 85度
          <br>· 外形尺寸：180mm（长）*100mm（宽）*121.92mm（高）
          <br>· 4个千兆网口和8个百兆网口
          <br>· M12连接器连接
          <br>· Web端管理
          <br>· 在线固件升级
          <br>· 主干线路硬件Bypass技术
          <br>· 支持网络自配置
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeName: "service",
      centerDialogVisible: false,
      productIndex: 0
    };
  },
  created() {

  },
  methods: {
    tabClick(tab) {
      if (tab.name == 'product') {
        this.title = '机载设备';
      } else {
        this.title = '机载融合信息系统';
      }
    },
    handleTabClick(value) {
      this.title = value;
    },
    itemClick(index) {
      this.productIndex = index;
      this.centerDialogVisible = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.product {
  width: 1240px;
  height: 100%;
  background-color: #fff;
}

.banner_content {
  position: relative;
  width: 1240px;
  height: 227px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;

  img {
    position: absolute;
    left: 0px;
  }

  .div_font {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 580px;
    width: 580px;

    .div_1 {
      display: flex;
      flex-direction: row;
      margin-top: 13px;
      align-items: flex-end;

      .font_1 {
        font-size: 64px;
        line-height: 64px;
        color: #000;
        font-weight: bolder;
        font-family: Source Han Sans CN;
        font-style: normal;
        letter-spacing: 5px;
      }

      .font_2 {
        font-size: 16px;
        color: #AEAEAE;
        margin-left: 10px;
        font-style: normal;
      }
    }

    .div_2 {
      margin-top: 20px;
      line-height: 180%;
      padding: 30px 40px;
      background-color: #E8A200;
      color: #fff;
      width: 100%;
      min-height: 76px;
    }
  }
}

::v-deep .el-tabs__item {
  width: 620px; /* 根据需要自定义宽度 */
  text-align: center;
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 20px;
  font-weight: bolder;
  color: #303133;
  position: relative;
}

.custom-tabs ::v-deep .el-tabs__active-bar {
  width: 200px !important;
  position: absolute;
  bottom: 0;
  left: calc((100% / 2 - 200px) / 2);
  height: 2px;
  background-color: #E8A200;
  z-index: 1;
}

::v-deep .el-radio-button__inner {
  border: 0px solid #DCDFE6;
}

::v-deep .el-radio-button .el-radio-button__inner {
  height: 40px;
  width: 160px;
  background-color: #F3F3F3;
  margin-right: 20px;
  border-left: 0px solid #F3F3F3;
  border-radius: 20px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  margin-right: 0px;
}

::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF;
  background-color: #1F6CC4;
  border-color: #1F6CC4;
  -webkit-box-shadow: -1px 0 0 0 #1F6CC4;
  box-shadow: 0 0 0 0 #1F6CC4;
}

.detail_content {
  display: flex;
  flex-direction: column;
  margin-top: 50px;

  i {
    font-size: 30px;
    color: #000;
    font-weight: bolder;
    font-style: normal;
    font-family: Source Han Sans CN;
  }

  span {
    background-color: #1F6CC4;
    width: 100px;
    height: 5px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px 0 50px 0;

    .detail_title {
      display: flex;
      flex-direction: row;
      width: 1160px;
      height: 26px;
      line-height: 26px;
      margin-bottom: 20px;

      .title_img {
        vertical-align: middle;
        margin-right: 10px;
        margin-top: 4px;
      }

      .i-first-child {
        font-size: 26px;
        color: #E8A200;
        font-style: normal;
        font-family: Source Han Sans CN;
        font-weight: bolder;
        vertical-align: middle;
      }
    }

    .detail_d2 {
      display: flex;
      flex-direction: row;
      width: 1160px;
      margin-top: 70px;
      .detail_font {
        font-size: 18px;
        font-weight: normal;
        line-height: 180%;
      }
    }

    .detail_font {
      font-size: 18px;
      margin-top: 0px;
      width: 1160px;
      line-height: 180%;
    }

    .main_pic {
      margin-top: 30px;
    }

    .detail7_img {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
.grid-content:hover {
  cursor: pointer;
}
.grid-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .p_img {
    border: 1px dotted #EBEBEB;
  }

  .p_title {
    font-size: 16px;
    color: #000;
    margin-top: 20px;
    margin-bottom: 50px;
  }
}
.grid-content-pma {
  position: relative;
  align-items: center;
  margin-top: 58px;

  .p_img {
    border: 1px dotted #EBEBEB;
  }

  .p_title {
    display: none;
    position: absolute;
    background-color: rgba(3, 0, 0, 0.61);
    bottom: -20px;
    font-size: 16px;
    color: #fff;
    line-height: 180%;
    padding: 10px;
    width: 392px;
  }
}

.grid-content-pma:hover .p_title {
  display: block;
}

.grid-content-pma:hover img {
  box-shadow: 0px 0px 10px blue;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}
.dialog_content {
  display: flex;
  flex-direction: row;
  .right_content {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    line-height: 200%;
    margin-left: 30px;
    width: 100%;
    .dialog_title {
      color: #00338B;
      font-size: 26px;
      font-weight: bolder;
      margin-bottom: 20px;
    }
    .dialog_item_title {
      font-weight: bolder;
      margin-top: 20px;
    }
  }
  .pz_title {
    background-color: #e3f2f9;
    font-weight: bolder;
    margin-bottom: 2px;
    margin-right: 2px;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }
  .pz_value {
    background-color: #e3f2f9;
    height: 40px;
    line-height: 40px;
  }
}

::v-deep .el-dialog {
  border-radius: 10px;
}
</style>